import React, { ComponentType, createContext } from 'react';

import { IDimensions } from 'components';

const DimensionsContext = createContext<IWithDimensions>({
  dimensions: {
    width: 0,
    height: 0,
  },
});
const DimensionsProvider = DimensionsContext.Provider;

export interface IWithDimensions {
  dimensions: IDimensions;
}

const withDimensions =
  <T extends IWithDimensions>(Component: ComponentType<T & IWithDimensions>) =>
  (props: T): unknown =>
    (
      <DimensionsContext.Consumer>
        {(providerProps: IWithDimensions) => <Component {...props} {...providerProps} />}
      </DimensionsContext.Consumer>
    );

export { DimensionsContext, DimensionsProvider, withDimensions };
